import {useContext} from 'react'
import {ProfitabilityContext} from '../../context'
import {DynamicTable} from '../../../../components/DynamicTable'
import {CUSTOMER_GROUP_COLUMNS} from '../../utils'
import CustomerGroupRow from './CustomerGroupTableRow'
import {parseCustomerGroupRow} from '../../parsings'
import {formatPrice} from '../../../../utils/common'
import CustomerGroupTableHeader from '../header/CustomerGroupTableHeader'

const CustomerGroupTable = () => {
  const {
    isFullView,
    CustomersGroupsData,
    isCustomersGroupsLoading,
    onSortingChangeCustomersGroups,
    customersGroupsFilters,
  } = useContext(ProfitabilityContext)

  if (isFullView) return null

  return (
    <div className='card border mb-10'>
      <div className='card-body p-7'>
        <CustomerGroupTableHeader />
        <DynamicTable
          data={CustomersGroupsData}
          sortableColumns={CUSTOMER_GROUP_COLUMNS}
          loading={isCustomersGroupsLoading}
          noDataMessage='No customer group data found'
          tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2 mb-0'
          TableRow={CustomerGroupRow}
          rowParsingFunction={parseCustomerGroupRow}
          onSortingChange={onSortingChangeCustomersGroups}
          filters={customersGroupsFilters}
          tableFooter={({columnTotals}: any) => (
            <tfoot className='border-top border-gray-200 text-dark fw-bolder'>
              <tr>
                <td>TOTAL</td>
                <td>{columnTotals.total_orders}</td>
                <td>{formatPrice(columnTotals.total_cost, false)}</td>
                <td>{formatPrice(columnTotals.total_revenue, false)}</td>
                <td></td>
                <td>{formatPrice(columnTotals.total_profit, false)}</td>
              </tr>
            </tfoot>
          )}
        />
      </div>
    </div>
  )
}

export default CustomerGroupTable
